import FlexWrapper, { FlexDirection } from "@gx/dls/containers/FlexWrapper";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";
import ProgressBar, { ProgressBarVariant } from "@gx/dls/metrics/ProgressBar";

interface CreateSourceProgressFooterProps {
  percentage: number;
  variant?: ProgressBarVariant;
  children: React.ReactNode;
}

const CreateSourceProgressFooter = ({
  percentage,
  variant = ProgressBarVariant.PRIMARY,
  children,
}: CreateSourceProgressFooterProps) => {
  return (
    <FlexWrapper direction={FlexDirection.COLUMN} fillWidth>
      <HorizontalDivider />
      <FlexWrapper direction={FlexDirection.COLUMN} gap={12} padding="16px" fillWidth>
        <ProgressBar variant={variant} percentage={percentage} />
        {children}
      </FlexWrapper>
    </FlexWrapper>
  );
};

export default CreateSourceProgressFooter;
